import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';
import LoadingScreen from 'react-loading-screen';
import logo from './assets/img/brand/LogoMobile.png';

function Loading() {
  return <LoadingScreen
 loading={true}
 spinnerColor='#9ee5f8'
 logoSrc={logo}
 >
 <div></div>
 </LoadingScreen>;
}

const Home = Loadable({
  loader: () => import('./views/Home/Home'),
  loading: Loading,
});

const Productos = Loadable({
  loader: () => import('./views/Productos'),
  loading: Loading,
});

const Cart = Loadable({
  loader: () => import('./views/Cart'),
  loading: Loading,
});

const Profile = Loadable({
  loader: () => import('./views/Perfil/UserProfile'),
  loading: Loading,
});

const Pedidos = Loadable({
  loader: () => import('./views/Pedidos'),
  loading: Loading,
});

const TyC = Loadable({
  loader: () => import('./views/Pages/TyC/TyC.js'),
  loading: Loading,
});

const SearchResult = Loadable({
  loader: () => import('./views/SearchResult/SearchResult.js'),
  loading: Loading,
});

const Destacados = Loadable({
  loader: () => import('./views/SearchResult/Destacados.js'),
  loading: Loading,
});

const Ofertas = Loadable({
  loader: () => import('./views/SearchResult/Ofertas.js'),
  loading: Loading,
});

const PrivatePolicy = Loadable({
  loader: () => import('./views/Pages/PrivatePolicy/PrivatePolicy.js'),
  loading: Loading,
});

const Categories = Loadable({
  loader: () => import('./components/Categories/Categories.js'),
  loading: Loading,
});

const routes = [
  { path: '/', exact: true, name: 'Home', component: Home },
  { path: '/productos', name: 'Productos', component: Productos },
  { path: '/producto', name: 'Producto', component: Productos },
  { path: '/cart', name: 'Cart', component: Cart },
  { path: '/tyc', name: 'TyC', component: TyC},
  { path: '/privacypolicies', name: 'PoliticasPrivacidad', component: PrivatePolicy},
  { path: '/perfil', name: 'Perfil', component: Profile, logged: true },
  { path: '/pedidos', name: 'Pedidos', component: Pedidos, logged: true },
  { path: '/ResultSearch/:text', name: 'SearchResult', component: SearchResult },
  { path: '/destacados/:code', name: 'Destacados', component: Destacados },
  { path: '/ofertas/:code', name: 'Ofertas', component: Ofertas },
  { path: '/categorias', name: 'Categories', component: Categories },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js